import { useState, useEffect } from "react";
import { Section, Field } from "./Section";

export default function SkillsSection({ resume, setResume, open, onToggle }) {
  // Local raw text state — preserves commas/spaces exactly as typed.
  // The resume state stores skills as an array; we only sync array on change.
  const [text, setText] = useState(() => resume.skills.join(", "));

  // If resume.skills is replaced externally (e.g. Load sample, Import,
  // Match JD), refresh the local text to reflect it.
  useEffect(() => {
    const joined = resume.skills.join(", ");
    // Only overwrite if the underlying array differs from the parsed text
    const parsed = text.split(",").map((s) => s.trim()).filter(Boolean);
    if (parsed.join("|") !== resume.skills.join("|")) {
      setText(joined);
    }
  }, [resume.skills]);

  const onChange = (v) => {
    setText(v);
    setResume((r) => ({
      ...r,
      skills: v.split(",").map((s) => s.trim()).filter(Boolean),
    }));
  };

  return (
    <Section id="skills" title="Skills" open={open} onToggle={onToggle}>
      <Field label="Comma separated">
        <textarea
          className="field-textarea min-h-[80px]"
          placeholder="React, TypeScript, Figma, Design Systems, Accessibility..."
          value={text}
          onChange={(e) => onChange(e.target.value)}
          data-testid="input-skills"
        />
      </Field>
      {resume.skills.length > 0 && (
        <div className="mt-3 flex flex-wrap gap-1.5">
          {resume.skills.map((s, i) => (
            <span key={`${s}-${i}`} className="text-xs px-2 py-1 border border-black/15 bg-neutral-50" data-testid={`skill-chip-${i}`}>
              {s}
            </span>
          ))}
        </div>
      )}
    </Section>
  );
}
